import _Typography from "@arco-design/web-react/es/Typography";
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React, { useEffect, useState } from 'react';
import { IconUndo } from '@arco-design/web-react/icon';
import style from './style.less';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
var getComponentName = function getComponentName(location) {
  var componentName = location.pathname.split('/').pop() || '';
  return componentName;
};
export default function StepHistory() {
  var dispatch = useDispatch();
  var history = useHistory();
  var _a = __read(useState(function () {
      return getComponentName(location);
    }), 2),
    componentName = _a[0],
    setComponentName = _a[1];
  var tokenHistory = useSelector(function (state) {
    return state.token.tokenHistory.getHistory(componentName);
  });
  useEffect(function () {
    var unlisten = history.listen(function () {
      setComponentName(getComponentName(location));
    });
    return unlisten;
  }, []);
  var isDisabled = location.pathname.split('/').splice(-2, 1)[0] === 'base';
  var backDisabled = isDisabled || !tokenHistory.canBack();
  var forwardDisabled = isDisabled || !tokenHistory.canForward();
  return /*#__PURE__*/React.createElement("span", {
    className: style['nav-actions-back'],
    style: {
      display: 'flex',
      marginRight: 10
    }
  }, /*#__PURE__*/React.createElement(_Typography.Text, {
    disabled: backDisabled,
    style: {
      cursor: 'pointer'
    }
  }, /*#__PURE__*/React.createElement(IconUndo, {
    onClick: function onClick() {
      if (!backDisabled) {
        dispatch({
          type: 'tokenBack',
          payload: componentName
        });
      }
    }
  })), /*#__PURE__*/React.createElement(_Typography.Text, {
    disabled: forwardDisabled,
    style: {
      cursor: forwardDisabled ? '' : 'pointer'
    }
  }, /*#__PURE__*/React.createElement(IconUndo, {
    onClick: function onClick() {
      if (!forwardDisabled) {
        dispatch({
          type: 'tokenForward',
          payload: componentName
        });
      }
    },
    style: {
      transform: 'scale(-1, 1)',
      marginLeft: 12
    }
  })));
}